<template>
    <div style="padding-bottom: 2rem; background-color: #000;">
        <div class="digital_bar">
            <div class="bat_item" v-for="(item, index) in barName" :key="index"
                 @mouseover="handleMouseOver(index)"
                 @mouseleave="handleMouseLeave(index)"
                 :style="{'background' : indexVal === index || activeIndex === index ? '#56defc' : '#000'}"
                 @click="handleClick(index, item)"
            >{{ item.title }}</div>
        </div>
    </div>
</template>

<script>
import { barData } from "../../util/constant"
export default {
    data() {
        return{
            activeIndex: -1,
            barName: barData[1].children,
            bg:'#000000'
        }
    },
    props: {
        indexVal : Number
    },
    methods: {
        handleMouseOver (index) {
            this.activeIndex = index
        },
        handleMouseLeave(index) {
            this.activeIndex = -1
        },
        handleClick(index, item) {
            this.$router.push(item.key)

        }
    }
}
</script>

<style scoped>
.digital_bar {
    display: flex;;
    top: 0;
    z-index: 9999;
    background: #000000;
    color: #fff;
    width: 100%;
    justify-content: center;
    height: 5rem;
    line-height: 5rem;
    text-align: center;
    align-items: center;
}
.bat_item {
    height: 60%;
    line-height: 300%;
    padding: 0 1rem 0 1rem;
    cursor: pointer;
}

</style>
